export enum PnProcedureConstants {
  SET_PN_PROCEDURE = 'pnProcedure/SET_PN_PROCEDURE',
  SET_DATE_TIME = 'pnProcedure/SET_DATE_TIME',
  SET_DATE = 'pnProcedure/SET_DATE',
  SET_TIME = 'pnProcedure/SET_TIME',
  SET_PTA = 'pnProcedure/SET_PTA',
  SET_PN_PROCEDURE_LIST = 'pnProcedure/SET_PN_PROCEDURE_LIST',
  SET_ADD_TO_TIMELINE = 'pnProcedure/SET_ADD_TO_TIMELINE',
  SAVE_PN_PROCEDURE = 'pnProcedure/SAVE_PN_PROCEDURE',
  SET_STATE = 'pnProcedure/SET_STATE',
  RESET_STATE = 'pnProcedure/RESET_STATE',
}
